import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom"; // Import Link from react-router-dom
import axios from 'axios';
import Modal from 'react-modal';
import '../styles.css';
import kumbhImage from '../kumbh.jpg';
import Navbar from "./Navbar";
import { FaTimes } from 'react-icons/fa'; // Import the close icon from react-icons

Modal.setAppElement('#root'); // Set the app element for the modal

const QRinfo = () => {
  const { id } = useParams();
  const [registration, setRegistration] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const apiUrl = 'https://api.infosware-test.in';

  useEffect(() => {
    const fetchRegistration = async () => {
      try {
        // console.log(`Fetching registration data from: ${apiUrl}/api/qrinfo/${id}`);
        const response = await axios.get(`${apiUrl}/api/qrinfo/${id}`);
        if (response.headers['content-type'].includes('application/json')) {
          console.log('Fetched registration:', response.data); // Log fetched data
          setRegistration(response.data);
        } else {
          console.error('Unexpected response format:', response.data);
          setRegistration(null);
        }
        setModalIsOpen(true); // Open modal when data is fetched
      } catch (error) {
        console.error('Error fetching registration:', error.response ? error.response.data : error.message);
        setModalIsOpen(true); // Open modal even if there is an error
      }
    };

    if (id) {
      fetchRegistration();
    }
  }, [apiUrl, id]);

  const handleModalClose = () => {
    setModalIsOpen(false);
  };

  const renderModalContent = () => {
    console.log('Rendering modal content with registration:', registration); // Log registration data
    if (!registration) {
      return <p className="smaller-text">No ID/URL found</p>;
    }
    return (
      <div>
        <p><strong>Name:</strong> {registration.name || 'N/A'}</p>
        {registration.phone1 && <p><strong>Family Head Number:</strong> {registration.phone1}</p>}
        {registration.phone2 && <p><strong>Phone 2:</strong> {registration.phone2}</p>}
        {registration.phone3 && <p><strong>Phone 3:</strong> {registration.phone3}</p>}
        {registration.phone4 && <p><strong>Phone 4:</strong> {registration.phone4}</p>}
        <p className="smaller-text mt-3">Note:-You are responsible for your own safety during the event.
          You consent to the recording of your personal information (including your name and phone number) for the purposes of event management.
          By participating, you acknowledge that you have read, understood, and agree to all the <Link to="/terms&conditions">Terms and Conditions</Link>.</p>
      </div>
    );
  };

  return (
    <div>
      <Navbar />
      <div className="image-container">
        <img src={kumbhImage} alt="Home Background" />
      </div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={handleModalClose}
        contentLabel="Registration Details"
        className="custom-modal"
        overlayClassName="custom-modal-overlay"
        shouldCloseOnOverlayClick={true}

      >
        <div className="modal-header" id="modalheader">
          <h5 className="modal-title" style={{ marginLeft: '10px' }}>User Details</h5> {/* Shifted the title to the left */}
          <button className="close-button" onClick={handleModalClose} style={{ backgroundColor: 'transparent', border: 'none' }}>
            <FaTimes color="red" size={20} /> {/* Red close icon */}
          </button>
        </div>
        <div className="modal-body" id="modalbody">
          {renderModalContent()}
        </div>
      </Modal>
    </div>
  );
};

export default QRinfo;
